/* eslint no-unused-vars: 0 */

import React from "react"
import AdminSearchProductPagination from "./pagination"
import AdminSearchModal from "./modal"
import AdminSearchPromotionResult from './search_promotion_result'

class AdminSearchPromotions extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      delete: [],
      prioritise: [],
      term: this.props.term,
      filter_term: "",
      display_save_modal: false
    };

    this.processUpdate = this.processUpdate.bind(this);
    this.handlePosition = this.handlePosition.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.setFilterTerm = this.setFilterTerm.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.performFilter = this.performFilter.bind(this);
    this.displaySaveModal = this.displaySaveModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      term: nextProps.term,
      filter_term: nextProps.filter_term
    });
  }

  setFilterTerm(e) {
    this.setState({
      filter_term: e.target.value
    });
  }

  performFilter() {
    this.props.set_filter_term(this.state.filter_term);
  }

  clearFilter() {
    this.setState({ filter_term: "" }, () => {
      this.props.set_filter_term("");
      this.props.getPromotions();
    });
  }

  displaySaveModal(value) {
    this.setState({
      display_save_modal: value
    });
  }

  processUpdate() {
    this.displaySaveModal(false);
    this.props.setSearchStatus(true);
    $.ajax({
      url: "/admin/site_search/bulk_process",
      data: {
        term: this.state.term,
        delete: this.state.delete,
        prioritise: this.state.prioritise,
        mode: this.props.mode
      },
      method: "POST",
      dataType: "JSON",
      success: () => {
        this.setState(
          {
            delete: [],
            prioritise: [],
            filter_term: ""
          },
          () => {
            setTimeout(() => {
              this.props.set_filter_term(this.state.filter_term);
              this.props.setSearchStatus(false);
            }, 3000);
          }
        );
      },
      error: () => {
        this.props.setSearchStatus(false);
        this.props.setErrorStatus(true);
      }
    });
  }

  handleDelete(step_id) {
    let new_delete = this.state.delete;
    if (new_delete.includes(step_id)) {
      new_delete.splice(new_delete.indexOf(step_id), 1);
    } else {
      new_delete.push(step_id);
    }
    this.setState({ delete: new_delete });
  }

  handlePosition(product_id, position) {
    if (product_id && position) {
      var current_priority = this.state.prioritise;
      var new_priority = {
        product_id: product_id,
        position: position
      };
      if (
        this.state.prioritise.filter(
          priority => priority.product_id === product_id
        ).length === 0
      ) {
        current_priority.push(new_priority);
      } else {
        current_priority.forEach(priority => {
          if (priority.product_id === product_id) {
            priority.position = position;
          }
        });
      }
      this.setState({
        prioritise: current_priority
      });
    }
  }

  render() {
    var clear_filter =
      this.state.filter_term !== "" ? (
        <span onClick={this.clearFilter}>Clear Filter</span>
      ) : (
        ""
      );

    var filter_mode =
      this.props.selected_mode === "Product" ? "Product Code" : "Description";
    var table_header =
      this.props.selected_mode === "Product" ? (
        <tr>
          <th>Position</th>
          <th>Step ID</th>
          <th>Description</th>
          <th>Part Code</th>
          <th>Stock Code</th>
          <th className="promotion">Promotion</th>
          <th>Delete</th>
        </tr>
      ) : (
        <tr>
          <th>Position</th>
          <th>Step ID</th>
          <th>Description</th>
          <th className="promotion">Promotion</th>
          <th>Delete</th>
        </tr>
      );
    return (
      <div className="admin-search--promotions">
        <h3>
          {this.props.mode} | <span>{this.state.term}</span>
          <div className="filter--products pull-right">
            {clear_filter}
            <input
              type="text"
              onChange={this.setFilterTerm}
              value={this.state.filter_term}
              placeholder={`Filter by ${filter_mode} (Case Sensitive)`}
            />
            <button
              onClick={() => {
                this.props.set_filter_term(this.state.filter_term);
              }}
            >
              <i className="icon-search" />
            </button>
          </div>
        </h3>
        <AdminSearchProductPagination
          per_page={50}
          products_total={this.props.total_results}
          current_page={this.props.page}
          setPage={this.props.setPage}
          mode={this.props.mode}
          displaySaveModal={this.displaySaveModal}
        />
        <AdminSearchModal
          title="Process Terms"
          body="The live CEF Website will now be updated. Are you sure you want to publish your changes?"
          display={this.state.display_save_modal}
          action={this.processUpdate}
          actionTitle="Yes"
          close={this.displaySaveModal}
          closeTitle="Close"
        />
        <table className="promoted--items table-bordered">
          <tbody>
            {table_header}
            {this.props.results.map((result, index) => {
              return (
                <AdminSearchPromotionResult
                  result={result}
                  key={`${result.step_id}-${this.state.term}`}
                  delete={this.handleDelete}
                  position={this.handlePosition}
                  selected_mode={this.props.selected_mode}
                  current_priority_list={this.state.prioritise}
                />
              );
            })}
          </tbody>
        </table>
        <AdminSearchProductPagination
          per_page={50}
          products_total={this.props.total_results}
          current_page={this.props.page}
          setPage={this.props.setPage}
          mode={this.props.mode}
          displaySaveModal={this.displaySaveModal}
        />
      </div>
    );
  }
}

export default AdminSearchPromotions;
